import {TableDefinition} from '~/backend/src/connectors/db/dbDefinition/DbDefinitionMapperUtilities';


const tableDefinition : TableDefinition = {
    table   : 'CI_PTYPE',
    fieldMap: {
        id              : 'CIPT_ID',
        statusId        : 'CIPT_CIST_ID',
        origin          : 'CIPT_ORIGIN',
        module          : 'CIPT_MODULE',
        name            : 'CIPT_NAME',
        modifierUserId  : 'CIPT_MODIFIER',
        modificationTime: 'CIPT_MODIFICATION_TIME',
        uuid            : 'CIPT_UUID'
    }
};

export default tableDefinition;
